(() => {
  const infoSelector = '.product-section .product__info-container';
  const actionsSelector = '.product__sale-box .product-form__buttons--input';

  function directAppBlocks(productInfo) {
    return Array.from(productInfo.children).filter((element) =>
      element.classList.contains('shopify-app-block')
    );
  }

  function ensureWishlistSlot(actions) {
    let slot = actions.querySelector(':scope > .novarlo-product-wishlist-slot');
    if (slot) return slot;

    slot = document.createElement('div');
    slot.className = 'novarlo-product-wishlist-slot';
    slot.setAttribute('data-novarlo-wishlist-slot', '');

    const submit = actions.querySelector(':scope > .product-form__submit');
    if (submit) submit.insertAdjacentElement('afterend', slot);
    else actions.appendChild(slot);

    return slot;
  }

  function moveShipping(actions, slot) {
    const saleBox = actions.closest('.product__sale-box');
    const shipping = saleBox?.querySelector(':scope > .product__free-shipping-bar, :scope > .product__free-shipping-bar--compact');
    if (!shipping) return;

    shipping.classList.add('product__free-shipping-bar--compact');
    if (shipping.parentElement !== actions) slot.insertAdjacentElement('afterend', shipping);
  }

  function moveWishlist(productInfo, actions, slot) {
    const movedBlock = slot.querySelector(':scope > .shopify-app-block');
    if (movedBlock) {
      actions.classList.add('novarlo-product-purchase-actions--has-wishlist');
      return;
    }

    const appBlocks = directAppBlocks(productInfo);

    // The governed Phase 1 composition has one direct app block in the upper
    // product-info column: Swish Wishlist King. Fail closed if another direct
    // app block is introduced rather than moving an unknown app.
    if (appBlocks.length !== 1) return;

    slot.appendChild(appBlocks[0]);
    actions.classList.add('novarlo-product-purchase-actions--has-wishlist');
  }

  function setupProductInfo(productInfo) {
    const actions = productInfo.querySelector(actionsSelector);
    if (!actions) return;

    actions.classList.add('novarlo-product-purchase-actions');

    const slot = ensureWishlistSlot(actions);
    moveWishlist(productInfo, actions, slot);
    moveShipping(actions, slot);
  }

  function setup(root = document) {
    if (root.matches?.(infoSelector)) setupProductInfo(root);
    root.querySelectorAll?.(infoSelector).forEach(setupProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup());
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('afterVariantChanged', () => setup());
})();
